import { features } from "app/features";

// Loads styles using feature flags:
// To load styles from JAPI content api, the styles are in: advert.stylename (object!)
// To load styles from the war, the styles are: legacyStyles[advert.stylename.id].
// To load advert.json from war, the styles are: legacyStyles[advert.style].

export const getAdvertStyles = (advert, legacyStyles) => {
  return {
    ...defaultAdvertStyle,
    ...(features.useInlineAdvertStyles
      ? parseInlineAdvertStyles(advert.stylename)
      : legacyStyles[advert?.stylename?.id]),
  };
};

const jsonFields = ["cardStyle", "footerStyle", "leftImgStyle", "centerImgStyle", "rightImgStyle", "rhsStyle"];

const parseInlineAdvertStyles = (styles) => {
  jsonFields.forEach((field) => (styles[field] = tryParse(styles[field])));
  return styles;
};

// JAPI content API sends JSON fields malformed as strings - parse back to JSON
function tryParse(str) {
  try {
    if (str && typeof value === "string") {
      return JSON.parse(str);
    }
  } catch (err) {
    console.warn("Failed to parse JSON in advert string:", str);
    return {};
  }
}

// defaults that can not be overridden
export const classes = {
  card: "advertcard d-flex align-items-center w-100 h-100 shadow ",
  row: "d-flex align-items-center w-100  ",
  title: "font-weight-lighter ",
};

// defaults that are overriden by custom styles
const defaultAdvertStyle = {
  card: "text-white",
  padding: " px-2 px-md-3 pt-1 pb-2 ",
  title: " h3 mb-1 card-title ",
  titleIcon: " fas fa-2x fa-fw mr-1 ",
  footer: " mb-0 p-0 ",
  button: " bg-white text-primary btn-sm font-weight-bold ml-sm-5 ",
  leftImg: " advert-image ml-1 ml-md-3 ",
  rightImg: "advert-image mr-1 mr-md-3",
};
